import { render, staticRenderFns } from "./InspectorTeamsStatsCard.vue?vue&type=template&id=237a6890&"
import script from "./InspectorTeamsStatsCard.vue?vue&type=script&lang=js&"
export * from "./InspectorTeamsStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports